import { Head, Link, router } from '@inertiajs/react'
import { track } from '../lib/events'

export default function AdminLayout({ currentEdition, editions, active, children }) {
  const tabs = [
    ['matches', 'Jogos & Resultados'],
    ['teams', 'Equipas'],
    ['photos', 'Fotos'],
  ]
  const activeLabel = tabs.find(([slug]) => slug === active)?.[1]

  function switchEdition(slug) {
    track('edition-switched', { edition: slug })
    router.get(`/${active}`, { edition_slug: slug }, { preserveState: false })
  }

  function logout() {
    router.delete('/logout')
  }

  return (
    <div className="page">
      <Head title={activeLabel ? `${activeLabel} · Organização` : 'Organização'} />
      <div className="top">
        <div className="crest">
          <img src="/cabreiroscup_logo.png" alt="Cabreiros Cup" />
        </div>
        <div className="wordmark">
          Cabreiros Cup<em>painel de organização</em>
        </div>
        <div className="when" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span className="pill admin-badge">ORGANIZADOR</span>
        </div>
      </div>
      <div className="nav">
        {tabs.map(([slug, label]) => (
          <Link
            key={slug}
            href={`/${slug}`}
            data={{ edition_slug: currentEdition?.slug }}
            className={active === slug ? 'on' : ''}
          >
            {label}
          </Link>
        ))}
        {editions && currentEdition && (
          <div className="edsw" style={{ marginLeft: 'auto' }}>
            {editions.map((e) => (
              <a
                key={e.slug}
                href="#"
                onClick={(ev) => {
                  ev.preventDefault()
                  switchEdition(e.slug)
                }}
                className={e.slug === currentEdition.slug ? 'on' : ''}
              >
                {e.name}
                <span className="edsw-date"> · {e.date}</span>
              </a>
            ))}
          </div>
        )}
        <a
          href="#"
          onClick={(ev) => {
            ev.preventDefault()
            logout()
          }}
        >
          Sair
        </a>
      </div>
      <div className="body">{children}</div>
    </div>
  )
}
